/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'file/7z': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M9 3a2 2 0 00-2 2v38a2 2 0 002 2h30a2 2 0 002-2V16.414c0-.081-.005-.162-.015-.242a1.004 1.004 0 00-.41-.99 1.978 1.978 0 00-.16-.182L29 3.586a1.986 1.986 0 00-.182-.161.999.999 0 00-.99-.41A2 2 0 0027.586 3H9zm18 2H9v38h30V17H28a1 1 0 01-1-1V5zm10.586 10L29 6.414V15h8.586z" _fill="#0B2C62"/><path pid="1" _fill="#0B2C62" d="M8 22h26v15H8z"/><path pid="2" d="M21.071 25.454h-5.126l-.12 1.122h3.893c-.968 1.188-1.342 1.87-1.672 2.651A10.864 10.864 0 0017.144 33h1.474c-.022-1.364.21-2.508.704-3.773.44-1.122 1.144-2.167 1.75-2.926v-.847zm1.213 0v1.144h3.619l-3.828 5.39V33h5.632v-1.144h-3.95l3.84-5.5v-.902h-5.313z" _fill="#fff"/>'
  }
})
